export const mockLeaderboard = [
  {
    id: 1,
    rank: 1,
    name: 'Aditya Sharma',
    points: 2500,
    year: '3',
    department: 'CSE',
    division: 'A',
    cluster: 'Development',
    events: ['HackTheFuture 2025', 'Web Dev Bootcamp'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Aditya&mouth=smile&eyes=default',
    badges: ['🏆', '⚡', '💻'],
  },
  {
    id: 2,
    rank: 2,
    name: 'Riya Patel',
    points: 2350,
    year: '3',
    department: 'CSE',
    division: 'B',
    cluster: 'AI',
    events: ['AI & ML Symposium', 'HackTheFuture 2025'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Riya&mouth=smile&eyes=default',
    badges: ['🥈', '🧠'],
  },
  {
    id: 3,
    rank: 3,
    name: 'Karthik N',
    points: 2200,
    year: '2',
    department: 'ECE',
    division: 'A',
    cluster: 'Programming',
    events: ['Competitive Programming 101'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Karthik&mouth=smile&eyes=default',
    badges: ['🥉', '🚀'],
  },
  {
    id: 4,
    rank: 4,
    name: 'Sneha Gupta',
    points: 2100,
    year: '4',
    department: 'CSE',
    division: 'C',
    cluster: 'Emerging Tech',
    events: ['Intro to Cloud Computing', 'Tech Talk'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sneha&mouth=smile&eyes=default',
    badges: ['☁️'],
  },
  {
    id: 5,
    rank: 5,
    name: 'Rahul Verma',
    points: 1950,
    year: '2',
    department: 'ISE',
    division: 'A',
    cluster: 'Development',
    events: ['Web Dev Bootcamp'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rahul&mouth=smile&eyes=default',
    badges: ['👨‍💻'],
  },
  {
    id: 6,
    rank: 6,
    name: 'Priya Singh',
    points: 1800,
    year: '3',
    department: 'CSE',
    division: 'B',
    cluster: 'Media & Design',
    events: ['UI/UX Design Workshop'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Priya&mouth=smile&eyes=default',
    badges: ['🎨'],
  },
  {
    id: 7,
    rank: 7,
    name: 'Amit Kumar',
    points: 1750,
    year: '1',
    department: 'CSE',
    division: 'D',
    cluster: 'Programming',
    events: ['Competitive Programming 101'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amit&mouth=smile&eyes=default',
    badges: ['⚡'],
  },
  {
    id: 8,
    rank: 8,
    name: 'Neha Roy',
    points: 1600,
    year: '2',
    department: 'ECE',
    division: 'B',
    cluster: 'PR',
    events: ['HackTheFuture 2025'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Neha&mouth=smile&eyes=default',
    badges: ['📢'],
  },
  {
    id: 9,
    rank: 9,
    name: 'Vikram Singh',
    points: 1550,
    year: '3',
    department: 'CSE',
    division: 'A',
    cluster: 'Competition',
    events: ['HackTheFuture 2025'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Vikram&mouth=smile&eyes=default',
    badges: ['🎯'],
  },
  {
    id: 10,
    rank: 10,
    name: 'Anjali Rao',
    points: 1400,
    year: '4',
    department: 'ISE',
    division: 'A',
    cluster: 'AI',
    events: ['AI & ML Symposium'],
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Anjali&mouth=smile&eyes=default',
    badges: ['🤖'],
  },
];
